import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import Moment from 'moment';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import Avatar from 'components/avatar';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Input from 'components/react-validation/components/input';
import Submit from '../../components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';
import Form from 'components/react-validation/components/form';
import PhoneNumberInput from 'components/PhoneNumberInput';
import * as LotActionType from '../constants';
import Translate from 'components/translate';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';

class SetNewOwnership extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    lotProfile: PropTypes.object,
    LotProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      purchaseDate: props.lotProfile.lotOwnerships
        ? null
        : props.lotProfile.coe,
      email: '',
      emailCheckType: null,
      userData: null,
      disabledClassBtn: '',
      isDisplayModalConfirm: false,
      dateError: null,
      enableHomeownerRequest: false,
      homeownerInvitation: true,
      isDisplayHOInvitationModal: false,
    };
  }

  onBindingLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_LOT_BY_ID_ASYNC,
      params: this.props.lotProfile.id,
      callback: () => {
        this.onCustomAction();
      },
    });
  };

  toolTip() {
    return (
      <Tooltip id='set-new-ownership-tooltip' className='in tooltip-siteone'>
        <span>
          If the email address does not appear to be your{' '}
          <Translate translateKey='homeowner' />, we will send an invitation to
          the <Translate translateKey='homeowner' /> to activate their account
          under your domain.
        </span>
      </Tooltip>
    );
  }

  onCustomAction = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.props.history.push(
      this.props.location.pathname + `?active=${queryParams.get('active')}`
    );
  };

  onValidateEmail = (value) => {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    if (emailPattern.test(value.trim())) {
      return true;
    }
    return false;
  };

  onChangeEmail = (e) => {
    this.setState({
      email: e.target.value,
    });
  };

  onClickToEditEmail = () => {
    // if (this.form) { this.form.resetForm(this.refs); }
    this.setState({
      emailCheckType: null,
      userData: null,
    });
  };

  onCheckEmail = () => {
    const { email } = this.state;
    if (this.onValidateEmail(email)) {
      this.props.dispatch({
        type: LotActionType.CHECK_HOMEOWNER_EXISTING_BY_EMAIL_ASYNC,
        params: {
          lotId: this.props.lotProfile.id,
          email,
        },
        callback: (type, data) => {
          this.onCallbackCheckEmail(type, data);
        },
      });
    }
  };

  onEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (this.onValidateEmail(this.state.email)) {
        this.onCheckEmail();
      }
    }
  }

  onCallbackCheckEmail = (type, data) => {
    this.setState({
      emailCheckType: type,
      userData: data,
    });
  };

  handleClose = () => {
    this.setState({
      isDisplayModalConfirm: false,
      isDisplayHOInvitationModal: false,
      homeownerInvitation:true
    },()=>{this.onCustomAction()});
  };
  handleCloseModal=()=>{
    this.setState({
      isDisplayHOInvitationModal: false,
    });
  }
  onSubmit = (e) => {
    e.preventDefault();
    if (
      !this.props.LotProfile.lotOwnerships &&
      this.state.purchaseDate !== this.props.LotProfile.coe
    ) {
      this.setState({ isDisplayModalConfirm: true });
    } else if(!this.state.homeownerInvitation){
      this.setState({ isDisplayHOInvitationModal: true });
    }else{
      this.onSetNewLot();
    }
    
  };

  onSetNewLot = () => {
    const { userData, purchaseDate, homeownerInvitation } = this.state;
    let purchaseDateValue = null;
    if (purchaseDate !== '') {
      purchaseDateValue = purchaseDate;
    }
    if (this.state.emailCheckType === 1) {
      if (this.state.enableHomeownerRequest === true) {
        const data = {
          ownerId: userData.id,
          purchaseDate: Moment.isMoment(purchaseDateValue)
            ? formatTimezoneDateTime(purchaseDateValue)
            : purchaseDateValue,
          isPrimary: true,
          allWarrantyDataAccess: false,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.SET_OWNERSHIP_TO_LOT_ASYNC,
          params: {
            lotId: this.props.lotProfile.id,
            data,
          },
          callback: () => {
            this.onBindingLot();
          },
        });
      } else if (this.state.enableHomeownerRequest === false) {
        const data = {
          ownerId: userData.id,
          purchaseDate: Moment.isMoment(purchaseDateValue)
            ? formatTimezoneDateTime(purchaseDateValue)
            : purchaseDateValue,
          isPrimary: true,
          allWarrantyDataAccess: true,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.SET_OWNERSHIP_TO_LOT_ASYNC,
          params: {
            lotId: this.props.lotProfile.id,
            data,
          },
          callback: () => {
            this.onBindingLot();
          },
        });
      }
    } else if (this.state.emailCheckType === 2) {
      if (this.state.enableHomeownerRequest === true) {
        const data = {
          purchaseDate: Moment.isMoment(purchaseDateValue)
            ? formatTimezoneDateTime(purchaseDateValue)
            : purchaseDateValue,
          lotId: this.props.lotProfile.id,
          firstName: userData.firstName,
          lastName: userData.lastName,
          phoneNumber: userData.phoneNumber,
          daytimePhoneNumber: userData.daytimePhoneNumber,
          email: userData.email,
          isSetOwnerShip: true,
          allWarrantyDataAccess: false,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.INVITE_HOMEOWNER_ASYNC,
          params: data,
          callback: () => {
            this.onBindingLot();
          },
        });
      } else if (this.state.enableHomeownerRequest === false) {
        const data = {
          purchaseDate: Moment.isMoment(purchaseDateValue)
            ? formatTimezoneDateTime(purchaseDateValue)
            : purchaseDateValue,
          lotId: this.props.lotProfile.id,
          firstName: userData.firstName,
          lastName: userData.lastName,
          phoneNumber: userData.phoneNumber,
          daytimePhoneNumber: userData.daytimePhoneNumber,
          email: userData.email,
          isSetOwnerShip: true,
          allWarrantyDataAccess: true,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.INVITE_HOMEOWNER_ASYNC,
          params: data,
          callback: () => {
            this.onBindingLot();
          },
        });
      }
    } else if (this.state.emailCheckType === 3) {
      if (this.state.enableHomeownerRequest === true) {
        const formData = this.form.getValues();
        const data = {
          purchaseDate: Moment.isMoment(purchaseDateValue)
            ? formatTimezoneDateTime(purchaseDateValue)
            : purchaseDateValue,
          lotId: this.props.lotProfile.id,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phoneNumber: this.phoneNumber.state.value,
          daytimePhoneNumber: this.daytimePhoneNumber.state.value,
          email: userData.email,
          isSetOwnerShip: true,
          allWarrantyDataAccess: false,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.INVITE_HOMEOWNER_ASYNC,
          params: data,
          callback: () => {
            this.onBindingLot();
          },
        });
      } else if (this.state.enableHomeownerRequest === false) {
        const formData = this.form.getValues();
        const data = {
          purchaseDate: Moment.isMoment(purchaseDateValue)
            ? formatTimezoneDateTime(purchaseDateValue)
            : purchaseDateValue,
          lotId: this.props.lotProfile.id,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phoneNumber: this.phoneNumber.state.value,
          daytimePhoneNumber: this.daytimePhoneNumber.state.value,
          email: userData.email,
          isSetOwnerShip: true,
          allWarrantyDataAccess: true,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.INVITE_HOMEOWNER_ASYNC,
          params: data,
          callback: () => {
            this.onBindingLot();
          },
        });
      }
    }
    this.onCheckHOInvitation();
  };

  validatePurchaseDate() {
    const { LotProfile } = this.props;
    if (LotProfile.lotOwnerships && LotProfile.lotOwnerships.length) {
      if (this.state.purchaseDate) {
        return true;
      }

      return false;
    }

    return true;
  }

  onErrorPhoneNumber = (status) => {
    this.setState({
      errorPhoneNumber: status,
    });
  };

  onErrorDaytimePhoneNumber = (status) => {
    this.setState({
      errorDaytimePhoneNumber: status,
    });
  };
  onCheckHomeowner = () => {
    this.setState({
      enableHomeownerRequest: !this.state.enableHomeownerRequest,
    });
  };
  onCheckHOInvitation = () => {
    this.setState({
      homeownerInvitation: !this.state.homeownerInvitation,
    });
  };
  render() {
    const { LotProfile } = this.props;
    const validatePurchaseDate = this.validatePurchaseDate();
    const breadcrumbs = [
      {
        title: 'Ownership info',
        url: '/lots',
        onCustomAction: this.onCustomAction,
      },
      { title: 'Set new ownership', url: '' },
    ];
    const {
      emailCheckType,
      dateError,
      errorPhoneNumber,
      errorDaytimePhoneNumber,
    } = this.state;
    const disabled =
      !emailCheckType ||
      dateError ||
      !validatePurchaseDate ||
      errorPhoneNumber ||
      errorDaytimePhoneNumber;
    return (
      <div className='lot-info-content' style={{ paddingLeft: 29 }}>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 0 }}>
            <label
              className='col-sm-12'
              style={{ paddingLeft: 6, fontWeight: 500, fontSize: 15 }}
            >
              Set new ownership
            </label>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 0 }}>
            <div className='col-sm-12' style={{ paddingLeft: 6 }}>
              <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 20 }}>
            <span
              className='col-sm-12'
              style={{ paddingLeft: 6, color: '#9B9B9B', marginBottom: 10 }}
            >
              New purchase date
            </span>
            <label className='col-sm-12' style={{ paddingLeft: 6 }}>
              Purchase date{' '}
              {LotProfile.lotOwnerships && LotProfile.lotOwnerships.length && (
                <span className='text-danger'>*</span>
              )}
            </label>
            <div className='col-sm-6' style={{ paddingLeft: 6 }}>
              <Datetime
                ref={(ref) => {
                  this.purchaseDate = ref;
                }}
                name='purchaseDate'
                inputProps={{ placeholder: 'mm/dd/yyyy' }}
                timeFormat={false}
                defaultValue={Moment(this.state.purchaseDate)}
                onChange={(purchaseDate) => {
                  if (
                    Moment(purchaseDate, 'MM/DD/YYYY', true).isValid() ||
                    purchaseDate === ''
                  ) {
                    this.setState({ purchaseDate, dateError: null });
                  } else {
                    this.setState({ dateError: 'Invalid datetime.' });
                  }
                }}
                closeOnSelect={true}/>
              {this.state.dateError && (
                <span
                  className='text-danger'
                  style={{ fontSize: 12, marginTop: 5 }}
                >
                  {this.state.dateError}
                </span>
              )}
            </div>
          </div>
        </div>
        {this.state.emailCheckType === null && (
          <div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <span
                  className='col-sm-12'
                  style={{ paddingLeft: 6, color: '#9B9B9B', marginBottom: 10 }}
                >
                  New primary owner
                </span>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>
                  Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i
                      className='fa fa-question-circle'
                      style={{ marginLeft: 10 }}
                    />
                  </OverlayTrigger>
                </label>
                <div
                  className='col-sm-6 email-block'
                  style={{ paddingLeft: 6 }}
                >
                  <input
                    type='text'
                    name='email'
                    ref='email'
                    className='form-control'
                    maxLength='256'
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    onKeyPress={this.onEnter.bind(this)}
                  />
                  <i
                    className={
                      'fa fa-check email-block-check-btn ' +
                      (!this.onValidateEmail(this.state.email)
                        ? 'disabled'
                        : '')
                    }
                    onClick={this.onCheckEmail}
                  />
                </div>
              </div>
            </div>
            <CheckBoxSingle
              checked={this.state.homeownerInvitation}
              onChecked={this.onCheckHOInvitation}
              ref={(c) => {
                this.check = c;
              }}
              label='Send the email invitation to the Homeowner?'
              className='checkbox-default'
              style={{ marginLeft: '5px' }}
            />
            <div className='row'>
              <div className='form-group col-sm-8'>
                <div
                  className='col-sm-12'
                  style={{ paddingLeft: 6, marginTop: 20 }}
                >
                  <span
                    className='btn btn-primary btn-siteone-default'
                    onClick={this.onCustomAction}
                  >
                    Cancel
                  </span>
                  <button
                    className='btn btn-primary btn-info btn-siteone'
                    onClick={this.onSubmit}
                    disabled={disabled}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.emailCheckType === 3 && (
          <Form
            className='form-horizontal'
            ref={(ref) => {
              this.form = ref;
            }}
            onSubmit={this.onSubmit}
            style={{ paddingLeft: 15 }}
          >
            <div className='row'>
              <div className='form-group col-sm-8'>
                <span
                  className='col-sm-12'
                  style={{ paddingLeft: 6, color: '#ccc', marginBottom: 10 }}
                >
                  New primary owner
                </span>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>
                  Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i
                      className='fa fa-question-circle'
                      style={{ marginLeft: 10 }}
                    />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                  <span>{this.state.userData.email}</span>
                  <i
                    className='fa fa-pencil email-block-edit-btn'
                    onClick={this.onClickToEditEmail}
                  />
                </div>
              </div>

              <div className='row' style={{ margin: 0 }}>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ paddingLeft: 6, fontWeight: 'normal' }}
                    >
                      First name <span className='text-danger'>*</span>
                    </label>
                    <Input
                      type='text'
                      name='firstName'
                      ref='firstName'
                      className='form-control'
                      max='40'
                      maxLength='40'
                      validations={[Vali.required, Vali.maxlength]}
                      divStyle={{ paddingLeft: 6 }}
                    />
                  </div>
                </div>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ paddingLeft: 6, fontWeight: 'normal' }}
                    >
                      Last name <span className='text-danger'>*</span>
                    </label>
                    <Input
                      type='text'
                      name='lastName'
                      ref='lastName'
                      className='form-control'
                      max='40'
                      maxLength='40'
                      validations={[Vali.required, Vali.maxlength]}
                      divStyle={{ paddingLeft: 6 }}
                    />
                  </div>
                </div>
              </div>
              <div className='row' style={{ margin: 0 }}>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ paddingLeft: 6, fontWeight: 'normal' }}
                    >
                      Phone number
                    </label>
                    <PhoneNumberInput
                      ref={(ref) => {
                        this.phoneNumber = ref;
                      }}
                      onError={this.onErrorPhoneNumber}
                      divStyle={{ paddingLeft: 6 }}
                    />
                  </div>
                </div>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15, paddingRight: 6 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ paddingLeft: 6, fontWeight: 'normal' }}
                    >
                      Daytime phone number
                    </label>
                    <PhoneNumberInput
                      ref={(ref) => {
                        this.daytimePhoneNumber = ref;
                      }}
                      onError={this.onErrorDaytimePhoneNumber}
                      divStyle={{ paddingLeft: 6 }}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-8 col-lg-8 col-xs-8'>
                  <CheckBoxSingle
                    checked={this.state.enableHomeownerRequest}
                    onChecked={this.onCheckHomeowner}
                    ref={(c) => {
                      this.check = c;
                    }}
                    label='Only requests created after purchase date are visible to this homeowner.'
                    className='checkbox-default'
                    style={{ marginLeft: '5px' }}
                  />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-sm-8'>
                  <div
                    className='col-sm-12'
                    style={{ paddingLeft: 20, marginTop: 20 }}
                  >
                    <span
                      className='btn btn-primary btn-siteone-default'
                      onClick={this.onCustomAction}
                    >
                      Cancel
                    </span>
                    <Submit
                      className='btn btn-primary btn-info btn-siteone'
                      disabled={disabled}
                    >
                      Save
                    </Submit>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
        {(this.state.emailCheckType === 2 || this.state.emailCheckType === 1) &&
          this.state.userData && (
            <div>
              <div className='row'>
                <div className='form-group col-sm-8'>
                  <span
                    className='col-sm-12'
                    style={{ paddingLeft: 6, color: '#ccc', marginBottom: 10 }}
                  >
                    New primary owner
                  </span>
                  <label className='col-sm-12' style={{ paddingLeft: 6 }}>
                    Email address <span className='text-danger'>*</span>
                    <OverlayTrigger placement='top' overlay={this.toolTip()}>
                      <i
                        className='fa fa-question-circle'
                        style={{ marginLeft: 10 }}
                      />
                    </OverlayTrigger>
                  </label>
                  <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                    <span>{this.state.userData.email}</span>
                    <i
                      className='fa fa-pencil email-block-edit-btn'
                      onClick={this.onClickToEditEmail}
                    />
                  </div>
                </div>

                <div className='form-group col-sm-8'>
                  {this.state.emailCheckType === 2 && (
                    <p
                      className='col-sm-12'
                      style={{ fontSize: 14, paddingLeft: 6 }}
                    >
                      The email address{' '}
                      <strong>{this.state.userData.email}</strong> already has
                      an account on SiteOne Services:
                    </p>
                  )}
                  {this.state.emailCheckType === 1 && (
                    <p
                      className='col-sm-12'
                      style={{ fontSize: 14, paddingLeft: 6 }}
                    >
                      The email address{' '}
                      <strong>{this.state.userData.email}</strong> is already
                      associated with this{' '}
                      <Translate translateKey='homeowner' /> account.
                    </p>
                  )}
                </div>
                <div className='form-group col-sm-8'>
                  <div className='block-existing-user'>
                    <Avatar src={null} size={80} />
                    <h4 className='cls-bold'>
                      {this.state.userData.displayName}
                    </h4>
                    <h5>{this.state.userData.email}</h5>
                    <h5>
                      <span style={{ color: '#ccc' }}>Phone number</span>
                      <span
                        style={{
                          fontSize: 16,
                          fontWeight: 600,
                          marginLeft: 15,
                        }}
                      >
                        {this.state.userData.phoneNumber}
                      </span>
                    </h5>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-sm-8'>
                  <CheckBoxSingle
                    checked={this.state.enableHomeownerRequest === true}
                    onChecked={this.onCheckHomeowner}
                    ref={(c) => {
                      this.check = c;
                    }}
                    label='Only requests created after purchase date are visible to this homeowner.'
                    className='checkbox-default'
                    style={{ marginLeft: '15px', bottom: '20px' }}
                  />
                  {/* </div> */}
                  {/* </div> */}
                  {/* <div className='row'> */}
                  {/* <div className='form-group col-sm-8'> */}
                  {/* <CheckBoxSingle
                  checked={this.state.homeownerInvitation}
                  onChecked={this.onCheckHOInvitation}
                  ref={c => { this.check = c; }}
                  label='Is the email sent to the homeowner or not?'
                  className='checkbox-default'
                  style={{marginLeft: '15px', bottom: '0px'}}
                /> */}
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-sm-8'>
                  <div
                    className='col-sm-12'
                    style={{ paddingLeft: 6, marginTop: 20 }}
                  >
                    <span
                      className='btn btn-primary btn-siteone-default'
                      onClick={this.onCustomAction}
                    >
                      Cancel
                    </span>
                    <button
                      className='btn btn-primary btn-info btn-siteone'
                      onClick={this.onSubmit}
                      disabled={disabled}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        {this.state.emailCheckType === 0 && this.state.userData && (
          <div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <span
                  className='col-sm-12'
                  style={{ paddingLeft: 6, color: '#ccc', marginBottom: 10 }}
                >
                  New primary owner
                </span>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>
                  Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i
                      className='fa fa-question-circle'
                      style={{ marginLeft: 10 }}
                    />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                  <span>{this.state.userData.email}</span>
                  <i
                    className='fa fa-pencil email-block-edit-btn'
                    onClick={this.onClickToEditEmail}
                  />
                </div>
              </div>

              <div className='form-group col-sm-8'>
                <p
                  className='col-sm-12'
                  style={{ fontSize: 14, paddingLeft: 6 }}
                >
                  The email address <strong>{this.state.userData.email}</strong>{' '}
                  is this <Translate translateKey='lot' plurals />
                  's current owner.
                </p>
              </div>
              <div className='form-group col-sm-8'>
                <div className='block-existing-user'>
                  <Avatar src={null} size={80} />
                  <h4 className='cls-bold'>
                    {this.state.userData.displayName}
                  </h4>
                  <h5>{this.state.userData.email}</h5>
                  <h5>
                    <span style={{ color: '#ccc' }}>Phone number</span>
                    <span
                      style={{ fontSize: 16, fontWeight: 600, marginLeft: 15 }}
                    >
                      {this.state.userData.phoneNumber}
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='form-group col-sm-8'>
                <div
                  className='col-sm-12'
                  style={{ paddingLeft: 6, marginTop: 20 }}
                >
                  <span
                    className='btn btn-primary btn-siteone-default'
                    onClick={this.onCustomAction}
                  >
                    Cancel
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal
          show={this.state.isDisplayModalConfirm}
          onHide={this.handleCloseModal}
          style={{ top: '20%' }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Purchase date does not match this lot's original COE date. If you
              save this purchase date, the original COE date will be updated.
              Continue?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className='text-right'>
              <button
                className='btn btn-primary btn-siteone-default'
                onClick={this.handleClose}
              >
                Cancel
              </button>
              <button
                className='btn btn-primary btn-info btn-siteone'
                style={{ marginLeft: 10 }}
                onClick={() => {
                  !this.state.homeownerInvitation ? 
                  this.setState({ isDisplayHOInvitationModal: true }):
                  this.onSetNewLot();
                }}
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.isDisplayHOInvitationModal}
          onHide={this.handleCloseModal}
          style={{ top: '20%' }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!this.state.homeownerInvitation &&
              <p>
                You have opted out to send homeowner the email invite! Please confirm.
              </p>
            }
          </Modal.Body>
          <Modal.Footer>
            <div className='text-right'>
              <button
                className='btn btn-primary btn-siteone-default'
                onClick={this.handleClose}
              >
                Cancel
              </button>
              <button
                className='btn btn-primary btn-info btn-siteone'
                style={{ marginLeft: 10 }}
                onClick={() => {
                  this.setState(
                    {
                      isDisplayHOInvitationModal: false,
                    },
                    () => {
                      this.onSetNewLot();
                    }
                  );
                }}
              >
                Confirm
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotProfile: state.LotStore.LotProfile,
  };
};

export default connect(mapStateToProps)(SetNewOwnership);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view-ownership-info-set-new-owner.js